"use client";

import { Link } from "@/components/common/Link";
import { Facebook, Instagram, Twitter } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <footer ref={ref} className={`w-full bg-dark-background text-foreground-dark py-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-6">
        {}
        <div className="flex-shrink-0">
          <Link to="/HomePage">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/best_coffee_canada_logo_white.png" alt="Best Coffee Canada" className="h-7 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-105" />
          </Link>
        </div>

        {}
        <nav className={`flex gap-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100" : "opacity-0"}`}>
          <Link to="/HomePage" className="text-sm font-medium hover:text-accent transition-colors duration-[var(--duration-fast)]">
            Home
          </Link>
          <Link to="/RoastersPage" className="text-sm font-medium hover:text-accent transition-colors duration-[var(--duration-fast)]">
            Roasters
          </Link>
          <Link to="/AboutPage" className="text-sm font-medium hover:text-accent transition-colors duration-[var(--duration-fast)]">
            About
          </Link>
          <Link to="/ContactPage" className="text-sm font-medium hover:text-accent transition-colors duration-[var(--duration-fast)]">
            Contact
          </Link>
        </nav>

        {}
        <div className="flex gap-4">
          <Link to="https://facebook.com" newTab className="text-foreground-dark hover:text-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-110" aria-label="Facebook">
            <Facebook className="size-5" />
          </Link>
          <Link to="https://instagram.com" newTab className="text-foreground-dark hover:text-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-110" aria-label="Instagram">
            <Instagram className="size-5" />
          </Link>
          <Link to="https://twitter.com" newTab className="text-foreground-dark hover:text-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-110" aria-label="Twitter">
            <Twitter className="size-5" />
          </Link>
        </div>
      </div>
    </footer>;
}